import React from 'react';
import { AuthProvider as OidcProvider, useAuth as useOidcAuth } from 'react-oidc-context';

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const oidcConfig = {
    authority: isLocal 
        ? "http://localhost:8081/realms/anavela" 
        : "https://auth.arhivanalitika.hr/realms/anavela",
    client_id: "anavela-web",
    redirect_uri: window.location.origin + "/login",
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
    }
};

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <OidcProvider {...oidcConfig}>{children}</OidcProvider>;
};

export function useAuth() {
    const auth = useOidcAuth();
    return {
        token: auth.user?.access_token || null,
        isAuthenticated: auth.isAuthenticated,
        isLoading: auth.isLoading,
        user: auth.user,
        signinRedirect: auth.signinRedirect,
        logout: () => auth.signoutRedirect(),
    };
}